import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { LEARNING_PAGE_SIDEBAR_WIDTH } from './LearningPageSidebar';
import { HasGate } from '../../features/accounts/components/HasGate';
import { jsx as _jsx } from "react/jsx-runtime";
const LearningPageMainSection = ({
  children
}) => {
  const {
    isNotTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    flexGrow: 1,
    overflow: "hidden",
    children: /*#__PURE__*/_jsx(HasGate, {
      fallback: /*#__PURE__*/_jsx(View, {
        inlineSize: isNotTablet ? `calc(100vw - ${LEARNING_PAGE_SIDEBAR_WIDTH}px)` : undefined,
        marginInline: "auto",
        maxInlineSize: isNotTablet ? '1180px' : '100vw',
        padding: "0",
        children: children
      }),
      gate: "Academy:UnifiedAcademy:Navigation",
      children: children
    })
  });
};
export default LearningPageMainSection;